import React, { useState, useEffect } from 'react';
import AppLoader from './AppLoader';

const FreeApps = ({ isVisible, Icons, Footer }) => {
    const [selectedApp, setSelectedApp] = useState(null);
    const [appTitle, setAppTitle] = useState('انتخاب برنامه');

    // مدیریت لود شدن پیش‌نیازها (مثل Chart.js)
    useEffect(() => {
        if (isVisible) {
            // بارگذاری Chart.js اگر وجود نداشته باشد
            if (!window.Chart && !document.querySelector('script[src*="chart.js"]')) {
                const chartScript = document.createElement('script');
                chartScript.src = 'https://cdn.jsdelivr.net/npm/chart.js';
                chartScript.async = true;
                document.body.appendChild(chartScript);
            }
        }
    }, [isVisible]);

    const handleSelectApp = (appId) => {
        setSelectedApp(appId);
        // در موبایل ممکن است بخواهیم اسکرول کنیم به سمت پایین
        if (window.innerWidth < 768) {
            setTimeout(() => {
                document.getElementById('app-main-view')?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <div id="page-free-apps" className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
            <div className="flex flex-col md:flex-row h-[calc(100vh-5rem)] md:h-[calc(100vh-8rem)] border-t border-slate-800">
                
                {/* --- Sidebar --- */}
                <aside className="w-full md:w-1/5 bg-slate-900 border-b md:border-b-0 md:border-l border-slate-800 flex flex-col h-[30vh] md:h-full flex-shrink-0">
                    <div className="p-4 border-b border-slate-800">
                        <h3 className="font-bold text-yellow-500 flex items-center gap-2 text-sm md:text-base">
                            <Icons.Menu size={20} />
                            فهرست برنامه‌ها
                        </h3>
                    </div>
                    <div className="flex-grow overflow-y-auto p-2 space-y-1 custom-scrollbar">
                        <div className="text-xs text-slate-500 px-2 py-1">لیست ابزارها</div>
                        
                        <SidebarButton 
                            id="excavation" 
                            label="ارزیابی خطر گود (مبحث ۷)" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons} 
                        />
						<SidebarButton 
							id="borehole_calculator" 
							label="محاسبه تعداد و عمق گمانه‌ها (مبحث ۷)" 
							activeId={selectedApp} 
							onClick={handleSelectApp} 
							Icons={Icons} 
						/>
                        <SidebarButton 
                            id="compressive_strength" 
                            label="مقاومت فشاری (بند ۱۰-۲-۴-۳)" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons} 
                        />
                        <SidebarButton 
                            id="fillet_weld" 
                            label="طراحی جوش گوشه (Fillet)" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons} 
                        />
                        <SidebarButton 
                            id="plastic_moment" 
                            label="محاسبه لنگر خمشی مقطع فولادی (مبحث ۱۰)" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons} 
						/>
                        <SidebarButton 
                            id="nominal_shear" 
                            label="برش اسمی (مبحث ۱۰)/بند 10-2-6-2-1" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons}
							
						/>
                        <SidebarButton 
                            id="nominal_shear_tf" 
                            label="برش اسمی (مبحث ۱۰)/بند 10-2-6-2-2" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons}
							
						/>
                        <SidebarButton 
                            id="moment_topBot" 
                            label="محاسبه لنگر تیر بتنی با آرماتور فشاری" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons}
                        />
						
                        <SidebarButton 
							id="moment_simple" 
							label="محاسبه Mn مطابق ACI و مقررات ملی" 
							activeId={selectedApp} 
							onClick={handleSelectApp} 
							Icons={Icons} 
						/>
						<SidebarButton 
							id="shear_simple" 
							label="محاسبه برش تیر بتنی" 
							activeId={selectedApp} 
							onClick={handleSelectApp} 
							Icons={Icons} 
						/>
						<SidebarButton 
							id="development_length" 
							label="محاسبه طول مهار Ld" 
							activeId={selectedApp} 
							onClick={handleSelectApp} 
							Icons={Icons} 
						/>
						
						<SidebarButton 
							id="overlap_length" 
							label="محاسبه طول پوششی (وصله)" 
							activeId={selectedApp} 
							onClick={handleSelectApp} 
							Icons={Icons} 
						/>
                        {/* دکمه جدید برای برنامه Moment-TShape */}
                        <SidebarButton 
                            id="Moment-TShape" 
                            label="محاسبه مقطع T شکل" 
                            activeId={selectedApp} 
                            onClick={handleSelectApp} 
                            Icons={Icons} 
                        />
                    </div>
                </aside>

                {/* --- Main Content --- */}
                <main id="app-main-view" className="w-full md:w-4/5 bg-[#020617] relative overflow-hidden flex flex-col h-[70vh] md:h-full flex-grow">
                    <div className="absolute inset-0 hero-pattern opacity-5 pointer-events-none"></div>
                    
                    {/* Header of the App View */}
                    <div className="p-4 md:p-6 border-b border-slate-800 bg-slate-900/50 backdrop-blur-sm z-10 flex justify-between items-center flex-shrink-0">
                        <h2 id="app-title" className="text-xl md:text-2xl font-black text-white flex items-center gap-3">
                            <span className="bg-slate-700 w-2 h-6 rounded-sm"></span>
                            {appTitle}
                        </h2>
                    </div>

                    {/* App Container */}
                    <div id="app-container" className="flex-grow overflow-y-auto relative z-10 custom-scrollbar text-right flex flex-col">
                        <div className="p-4 md:p-8 flex-grow">
                            
                            {/* The New React AppLoader Component */}
                            <AppLoader 
                                appId={selectedApp} 
                                onTitleChange={setAppTitle}
                            />

                        </div>
                        {Footer && <Footer />}
                    </div>
                </main>
            </div>
        </div>
    );
};

// کامپوننت کمکی برای دکمه‌های سایدبار جهت تمیزتر شدن کد
const SidebarButton = ({ id, label, activeId, onClick, Icons }) => {
    const isActive = activeId === id;
    return (
        <button 
            onClick={() => onClick(id)} 
            className={`app-sidebar-item w-full text-right p-3 rounded-lg transition-all text-sm flex items-center justify-between group 
                ${isActive 
                    ? 'bg-yellow-500/10 text-yellow-500 border-r-2 border-yellow-500 font-bold' 
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`}
        >
            <span>{label}</span>
            {isActive && <Icons.CheckCircle size={16} className="text-emerald-500" />}
        </button>
    );
};

export default FreeApps;